import React, { useCallback } from "react";
import * as LogRocket from "logrocket";
import copy from "copy-to-clipboard";
import { toast } from "react-toastify";
import { useHistory } from "react-router-dom";
import { styled } from "@mui/material";
import { DiscountCodeState } from "../../../../api/discounts/index.types";
import { useDiscountsContext } from "../../../../context";

interface IProps {
  discount: DiscountCodeState;
}

export const StyledDivWithHover = styled("div")({
  "&:hover": {
    cursor: "pointer !important",
    background: "rgba(128, 128, 128, 0.4) !important",
  },
});

const DiscountCodeTableData: React.FC<IProps> = ({ discount }) => {
  const history = useHistory();
  const { columns } = useDiscountsContext();

  const handleClickDiscountCode = useCallback(
    (e: React.MouseEvent, id: string) => {
      if (e.type === "click") {
        history.push(`/discount/${id}`);
      } else if (e.type === "contextmenu") {
        LogRocket.track("Discounts: Copy/ View Code");
        copy(id);
        toast.info(`${id} copied`, {
          position: "bottom-right",
          autoClose: 2000,
          closeOnClick: true,
          pauseOnHover: true,
        });
      }
    },
    [history, LogRocket]
  );

  return (
    <td
      className="hover"
      style={{ textAlign: columns.length <= 2 ? "center" : "right" }}
      onContextMenu={(e) => {
        e.preventDefault();
        handleClickDiscountCode(e, discount.code);
      }}
    >
      <StyledDivWithHover
        onClick={(e) => {
          discount.id !== -1 && handleClickDiscountCode(e, discount.code);
        }}
        tabIndex={-1}
        role="button"
      >
        {discount.code}
      </StyledDivWithHover>
    </td>
  );
};

export default DiscountCodeTableData;
